import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import {
	Dropdown,
	DropdownItem,
	DropdownMenu,
	DropdownToggle,
	Row,
} from 'reactstrap';
import { Button } from '@componentes/buttons';
import { Colxx } from '@common/customBootstrap';
import { useEffect } from 'react';
import Avatar from '@componentes/avatar';
import './login.css';
import Logo from '../../svg/logo';
import { FcApproval, FcHighPriority } from 'react-icons/fc'
export function Login(props) {
	const [username, setUsername] = useState('');
	const [user, setUser] = useState(''); //input
	const [accounts, setAccounts] = useState([]);
	const [confirmUser, setConfirmUser] = useState(props.confirmUser);
	const [email, setEmail] = useState(props.email);
	const [password, setPassword] = useState('');
	const [newPassword, setNewPassword] = useState('');
	const [newPasswordConfirm, setNewPasswordConfirm] = useState('');
	const [passwordRecovery, setPasswordRecovery] = useState(
		props.passwordRecovery
	);
	const [msgColor, setMsgColor] = useState('');
	const [msgText, setMsgText] = useState('');
	const [currentAccount, setCurrentAccount] = useState('');
	const [toggleLang, setToggleLang] = useState(false);
	const [toggleAccount, setToggleAccount] = useState(false);
	const [addAccount, setAddAccount] = useState(false);
	const [toggleCompanies, setToggleCompanies] = useState(false);
	const formRef = useRef();

	useEffect(()=>{
		props.errorMessage && checkError(true);
	},[props.errorMessage])

	function onGoback(){
		setAddAccount(!addAccount);
		setConfirmUser(false);
		props.onCompanies([]);
		props.setShowCompanies(false);
		props.setResetarSenha(false);
		setNewPassword('');
		setNewPasswordConfirm('');
	}

	function checkError(show) {
		if (
			(passwordRecovery && !props.errorMessage) ||
			(!show && passwordRecovery)
		) {
			setMsgColor('');
			return setMsgText(props.recoveryText);
		} else if (
			!props.errorMessage ||
			(!passwordRecovery && !confirmUser && !user) ||
			(!passwordRecovery && confirmUser && !password) ||
			(passwordRecovery && !email) ||
			!show
		) {
			if (formRef.current && formRef.current.className.includes('error')) {
				formRef.current.className = formRef.current.className.replace(
					' error',
					''
				);
			}
			setMsgColor('');
			return setMsgText('');
		} else {
			if (props.errorMessage && show) {
				setMsgColor('danger');
				if (
					(!passwordRecovery && !confirmUser && user) ||
					(!passwordRecovery && confirmUser && password) ||
					(passwordRecovery && email)
				) {
					setMsgText(props.errorMessage);
					setPassword('');
					if (formRef.current && !formRef.current.className.includes('error')) {
						formRef.current.className += ' error';
					}
				}
			}
		}
	}

	useEffect(() => {
		setEmail('');
		setPassword('');
		setUser('');
		checkError();
	}, [passwordRecovery, addAccount]);

	useEffect(() => {
		checkError(true);
	}, [props]);

	useEffect(() => {
		props.confirmUser !== confirmUser && setConfirmUser(props.confirmUser);
		props.accounts.length !== accounts.length && setAccounts(props.accounts);
		props.currentAccount !== currentAccount &&
			setCurrentAccount(props.currentAccount);

		if (props.accounts.length > 0 && !props.currentAccount) {
			setCurrentAccount(props.accounts[0]);
			setConfirmUser(true);
			props.onAccount(props.accounts[0]);
		}

		if (props.passwordRecovery) {
			setMsgColor('');
			setMsgText(props.recoveryText);
		} else {
			setMsgColor('');
			setMsgText('');
		}
	}, [props.accounts]);

	useEffect(() => {
		if (currentAccount) {
			const _user = currentAccount;
			_user.username && setUsername(_user.username);
			_user.password && setPassword(_user.password);
		}else{
			setUsername('');
			setPassword('');
		}
	}, [currentAccount]);

	function changePasswordRecovery() {
		setPasswordRecovery(!passwordRecovery);
		checkError();

		if (!username) {
			setConfirmUser(false);
		} else {
			setConfirmUser(true);
		}
	}

	function changeUser(e) {
		checkError();
		setUser(e);
		props.setSelectedCompanies(null);
	}

	function changePassword(e) {
		checkError();
		setPassword(e);
	}
	function changeEmail(e) {
		checkError();
		setEmail(e);
	}

	const CustomSpan = (props) => {
		const { children, ...rest } = props;
		return <span {...rest}>{children}</span>;
	};

	const Message = ({ show, text, color }) => {
		return (
			<span data-color={color} data-show={`${show}`} className="form-feedback">
				{text}
			</span>
		);
	};

	Message.propTypes = {
		show: PropTypes.bool,
		color: PropTypes.string,
		text: PropTypes.string,
	};

	Message.defaultProps = {
		color: '',
		text: '',
		show: false,
	};

	function changeLang(val) {
		props.onLang(val.value);
	}

	function changeAccount(val) {
		if (accounts.length === 1) return;
		const account = accounts.find((x) => x.username === val.username);
		setCurrentAccount(account);
		setPassword('');
		props.onAccount(account);
	}

	function submit(event) {
		event.preventDefault();

		if (!props.resetPassword && !confirmUser) {
			props.onGetUser(user);
		} else if (!props.resetPassword && passwordRecovery) {
			props.onGetRecovery(email);
		} else if(!props.resetPassword){
			props.onGetPassword(password);
		}else{
			 props.onResetSenha(newPassword);
			 return //onGoback();
		}
		checkError(true);
	}

	function accountDel(id) {
		if (accounts.length === 1) {
			setConfirmUser(false);
			setUsername('');
			setUser('');
			setCurrentAccount(null);
			setMsgText('');
			setMsgColor('');
			setAccounts([]);
			props.onAccounts([]);

			return props.onAccount(null);
		}
		if (id) {
			let _accounts = [];
			let changeUser = false;

			accounts.map((x) => {
				if (x.id !== id) {
					_accounts.push(x);
				} else if (x.id === id && x.username === username) {
					changeUser = true;
				}
			});
			if (changeUser) {
				setCurrentAccount(_accounts[0]);
				setUsername(_accounts[0].username);
				props.onAccount(_accounts[0]);
			}

			setAccounts(_accounts);
			props.onAccounts(_accounts);
		}
	}

	useEffect(() => {
		const verifyKeypress = (event) => {
			if (event.key === 'Enter') {
				event.preventDefault();
				document.getElementById('login-submit').click();
			}
		};
		let input = document.getElementById('user');
		input = !input ? document.getElementById('password') : input;
		input = !input ? document.getElementById('recovery') : input;
		input = !input ? document.getElementById('newpasswordconfirm') : input;

		input.addEventListener('keypress', verifyKeypress);

		return () => {
			input.removeEventListener('keypress', verifyKeypress);
		};
	}, []);

	return (
		<div className="vivace-login-page">
			<div className="vivace-login-container">
				<div className="vivace-login-topo"></div>
				<div className="vivace-login-box">
					{props.themeSwitch && (
						<div className="vivace-login-theme">
							<ThemeSwitch
								theme={props.theme}
								onTheme={() => props.onTheme(props.theme)}
							/>
						</div>
					)}
					<div className="vivace-login-logo">
						<Logo />
					</div>
					<div className="vivace-login-form">
						<form
							ref={formRef}
							className="form"
							id="form"
							onSubmit={(e) => submit(e)}
						>
							<Row>
								<Colxx xl={12}>
									{!confirmUser && !props.resetPassword ? (
										<div className="vivace-login-sistema">
											{props.text}
											<span>({props.title})</span>
										</div>
									) : (
										!passwordRecovery && !props.resetPassword && (
											<div className="vivace-login-sistema">
												<div>
													<Dropdown
														isOpen={toggleAccount}
														toggle={() => setToggleAccount(!toggleAccount)}
													>
														<DropdownToggle data-toggle="dropdown" tag="div">
															<div className="wellcome-login">
																{props.wellcome}, {username}{' '}
																<i className="mv-basico-seta_baixo_simples"></i>
															</div>
														</DropdownToggle>
														<DropdownMenu
															onClick={() => setToggleAccount(!toggleAccount)}
														>
															{accounts.map((x, i) => (
																<div className="custom-item" key={i}>
																	<div className="d-flex align-items-center ">
																		<Avatar image={x.image}>
																			{x.username}
																		</Avatar>
																		<div
																			className="account-item"
																			onClick={() => {
																				changeAccount(x);
																				setToggleAccount(!toggleAccount);
																			}}
																		>
																			<div>{x.name}</div>
																			<div>{x.username}</div>
																		</div>
																		<div
																			className="account-del"
																			onClick={() => {
																				accountDel(x.id);
																				setToggleAccount(!toggleAccount);
																			}}
																		>
																			<i className="mv-basico-excluir"></i>
																		</div>
																	</div>
																</div>
															))}

															<DropdownItem divider />
															<div
																className="custom-item"
																onClick={() => {
																	onGoback();
																}}
															>
																<div className="d-flex align-items-center ">
																	<i className="mv-basico-cidadao_cadastrar"></i>
																	{props.newAccount}
																</div>
															</div>
														</DropdownMenu>
													</Dropdown>
												</div>
											</div>
										)
									)}
								</Colxx>
							</Row>
							<Row>
								<Colxx xl={12}>
									{(!passwordRecovery && !props.resetPassword && !confirmUser) ||
									(!passwordRecovery && !props.resetPassword && !accounts) ? (
										<div className="form-group icon-input">
											<input
												required={!passwordRecovery && !confirmUser}
												value={user}
												className="form-control user"
												type="text"
												id="user"
												name="user"
												onChange={(e) => changeUser(e.target.value)}
											/>
											<label
												htmlFor="user"
												aria-valuetext={user ? true : false}
											>
												{props.placeholdUser}
											</label>
											<CustomSpan position="start">
												<i className="mv-basico-usuario"></i>
											</CustomSpan>
										</div>
									) : !passwordRecovery && !props.resetPassword && confirmUser ? (
										<div className="form-group icon-input">
											<input
												required={!passwordRecovery && confirmUser}
												value={password}
												className="form-control user"
												type="password"
												id="password"
												name="password"
												onChange={(e) => changePassword(e.target.value)}
											/>
											<label htmlFor="password">
												{props.placeholdPassword}
											</label>
											<CustomSpan position="start">
												<i className="mv-basico-chave"></i>
											</CustomSpan>
										</div>
									) : !props.resetPassword && (
										<div className="form-group icon-input">
											<input
												pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
												required={passwordRecovery}
												value={email}
												className="form-control"
												type="text"
												id="recovery"
												name="recovery"
												onChange={(e) => changeEmail(e.target.value)}
											/>
											<label htmlFor="recovery">{props.placeholdEmail}</label>
											<CustomSpan position="start">
												<i className="mv-basico-mensagem"></i>
											</CustomSpan>
										</div>
									)}

									{props.resetPassword &&
									<React.Fragment>
										<div className="form-group icon-input">
										<input
											required
											pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{8,16}$"
											value={newPassword}
											className="form-control user"
											type="password"
											id="newpassword"
											name="newpassword"
											onChange={(e) => setNewPassword(e.target.value)}
										/>
										<label htmlFor="newpassword" aria-valuetext={newPassword.length>0} >
											{props.placeholdPassword}
										</label>
										<CustomSpan position="start">
											<i className="mv-basico-chave"></i>
										</CustomSpan>
									</div>
									<div className="form-group icon-input">
											<input
												required
												pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{8,16}$"
												value={newPasswordConfirm}
												className="form-control user"
												type="password"
												id="newpasswordconfirm"
												name="newpasswordconfirm"
												onChange={(e) => setNewPasswordConfirm(e.target.value)}
											/>
											<label htmlFor="newpasswordconfirm" aria-valuetext={newPasswordConfirm.length>0}>
												{props.placeholdPasswordConfirm}
											</label>
											<CustomSpan position="start">
												<i className="mv-basico-chave"></i>
											</CustomSpan>
										</div>
										<ul>
										<li>{newPassword.match('[a-z]') ? <FcApproval /> : <FcHighPriority />}  {` ${props.lowercasePasswordLabel}`}</li>
										<li>{newPassword.match('[A-Z]') ? <FcApproval /> : <FcHighPriority />} {` ${props.uppercasePasswordLabel}`}</li>
										<li>{newPassword.match('[0-9]') ? <FcApproval /> : <FcHighPriority />} {` ${props.numberPasswordLabel}`}</li>
										<li>{newPassword.match('[!@#$%^&*_=+-]') ? <FcApproval /> : <FcHighPriority />} {` ${props.caracterPasswordLabel}`}</li>
										<li>{newPassword.length >= 8 ? <FcApproval /> : <FcHighPriority />} {` ${props.lenghtEightPasswordLabel}`}</li>
										<li>{newPassword && newPasswordConfirm && newPasswordConfirm.length>0 && newPasswordConfirm=== newPassword ? <FcApproval /> : <FcHighPriority />} {` ${props.placeholdPasswordMustBeEqual}`}</li>
										</ul>
									</React.Fragment>
									}

									{props.showCompanies && (
										<div className="card flex justify-content-center">
											<Dropdown
												isOpen={toggleCompanies}
												toggle={() => setToggleCompanies(!toggleCompanies)}
											>
												<DropdownToggle data-toggle="dropdown" tag="div">
													<div className="select-companies">
														{props.selectedCompanies
															? props.selectedCompanies[props.keyCompanies]
															: props.placeholdCompanies}{' '}
														<i className="mv-basico-seta_baixo_simples"></i>
													</div>
												</DropdownToggle>
												<DropdownMenu
													onClick={() => setToggleCompanies(!toggleCompanies)}
												>
													{props.optionsCompanies.map((x, i) => (
														<div
															className="custom-item"
															key={i}
															onClick={() => {
																props.onCompanies(x);
																props.setSelectedCompanies(x);
																setToggleCompanies(!toggleCompanies);
															}}
														>
															<div className="d-flex align-items-center ">
																<div className="account-item">
																	<div>{x[props.keyCompanies]}</div>
																</div>
															</div>
														</div>
													))}
												</DropdownMenu>
											</Dropdown>
										</div>
									)}
									<div className="input-container">
										<Message show={true} color={msgColor} text={msgText} />
									</div>
								</Colxx>
							</Row>
							<Row>
								{confirmUser ? (
									<Colxx xl={12}>
										<a
											className="vivace-senha-link"
											href="#"
											onClick={() =>
											onGoback()
											}
										>
											{props.goback}
										</a>
									</Colxx>
								) : !props.hideForgotPassword ? (
									<Colxx xl={12}>
										<span
											className="vivace-senha-link"
											onClick={() => changePasswordRecovery()}
										>
											{passwordRecovery ? props.goback : props.forgotpassword}
										</span>
									</Colxx>
								) : (
									<br />
								)}
							</Row>
							<div className="btn-container">
								<Row>
									<Colxx xl={12}>
										<div className="mb-2">
											<Button
												id="login-submit"
												disabled={
													(!props.resetPassword && !passwordRecovery && !confirmUser && !user) ||
													(!props.resetPassword && !passwordRecovery && confirmUser && !password) ||
													(!props.resetPassword && passwordRecovery && !email) ||
													(!props.resetPassword && props.showCompanies && !props.selectedCompanies)||
													props.resetPassword && !newPassword.match('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{8,16}') || newPasswordConfirm !== newPassword
												}
												type="submit"
												primary
												block
												label={props.inputEnter.value}
											/>
										</div>
										{props.inputBio.value && (
											<div>
												<Button
													icon={props.inputBio.icon}
													block
													label={props.inputBio.value}
													onClick={props.onClickBio}
												/>
											</div>
										)}
									</Colxx>
								</Row>
							</div>
						</form>
						{props.version && (
							<div className="vivace-login-version">{props.version}</div>
						)}
					</div>
					<div className="vivace-login-rodape">
						<div className="lang">
							<div className="d-flex">
								<Dropdown
									isOpen={toggleLang}
									toggle={() => setToggleLang(!toggleLang)}
								>
									<DropdownToggle data-toggle="dropdown" tag="span">
										{props.currentLang}
									</DropdownToggle>
									<DropdownMenu onClick={() => setToggleLang(!toggleLang)}>
										{props.langs.map((x, i) => (
											<div
												className="custom-item"
												key={i}
												onClick={() => changeLang(x)}
											>
												{x.label}
											</div>
										))}
									</DropdownMenu>
								</Dropdown>
							</div>
						</div>
						<div className="links">
							<a href={props.helpRote}>{props.help}</a>
							<a href={props.aboutRote}>{props.about}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

Login.propTypes = {
	lowercasePasswordLabel: PropTypes.string,
	uppercasePasswordLabel: PropTypes.string,
	numberPasswordLabel: PropTypes.string,
	caracterPasswordLabel: PropTypes.string,
	lenghtEightPasswordLabel: PropTypes.string,
	version: PropTypes.string,
	themeSwitch: PropTypes.bool,
	theme: PropTypes.string,
	recoveryText: PropTypes.string,
	forgotpassword: PropTypes.string,
	help: PropTypes.string,
	about: PropTypes.string,
	helpRote: PropTypes.string,
	aboutRote: PropTypes.string,
	user: PropTypes.string,
	password: PropTypes.string,
	currentLang: PropTypes.any,
	langs: PropTypes.array,
	accounts: PropTypes.any,
	onLang: PropTypes.func,
	onChange: PropTypes.func,
	onClickEnter: PropTypes.func,
	onClickBio: PropTypes.func,
	onGetUser: PropTypes.func,
	onGetPassword: PropTypes.func,
	onGetRecovery: PropTypes.func,
	onAccount: PropTypes.func,
	onTheme: PropTypes.func,
	inputBio: PropTypes.any,
	onCurrentUser: PropTypes.any,
	onAccounts: PropTypes.any,
	inputEnter: PropTypes.object,
	passwordRecovery: PropTypes.bool,
	placeholdUser: PropTypes.string,
	placeholdPassword: PropTypes.string,
	placeholdPasswordConfirm: PropTypes.string,
	placeholdPasswordMustBeEqual : PropTypes.string,
	placeholdEmail: PropTypes.string,
	goback: PropTypes.string,
	errorMessage: PropTypes.string,
	userErrorMessage: PropTypes.string,
	passwordErrorMessage: PropTypes.string,
	forgotPasswordErrorMessage: PropTypes.string,
	wellcome: PropTypes.string,
	newAccount: PropTypes.string,
	email: PropTypes.string,
	title: PropTypes.string,
	text: PropTypes.string,
	currentAccount: PropTypes.any,
	children: PropTypes.any,
	callback: PropTypes.any,
	confirmUser: PropTypes.bool,
	hideForgotPassword: PropTypes.bool,
	keyCompanies: PropTypes.string,
	placeholdCompanies: PropTypes.string,
	optionsCompanies: PropTypes.any,
	showCompanies: PropTypes.bool,
	onCompanies: PropTypes.func,
	selectedCompanies: PropTypes.any,
	setSelectedCompanies: PropTypes.func,
	resetPassword: PropTypes.bool,
	onResetSenha: PropTypes.func,
};

Login.defaultProps = {
	lowercasePasswordLabel: 'Pelo menos uma letra minúscula',
	uppercasePasswordLabel: 'Pelo menos uma letra maiúscula',
	numberPasswordLabel: 'Pelo menos um número',
	caracterPasswordLabel: 'Pelo menos um caracter',
	lenghtEightPasswordLabel: 'Pelo menos uma 8 caracteres',
	email: '',
	themeSwitch: false,
	theme: 'light',
	confirmUser: false,
	passwordRecovery: false,
	inputEnter: { value: '' },
	inputBio: { value: '', icon: '' },
	forgotpassword: 'Esqueceu a senha?',
	wellcome: 'Bem-vindo',
	placeholdUser: 'Usuário',
	placeholdPassword: 'Senha',
	placeholdPasswordConfirm: 'Confirmar Senha',
	placeholdPasswordMustBeEqual: 'As senhas devem ser iguais',
	placeholdEmail: 'Email',
	errorMessage: '',
	userErrorMessage: 'Usuário não existe',
	passwordErrorMessage: 'Senha Inválida',
	forgotPasswordErrorMessage: 'Email não cadastrado',
	recoveryText:
		'Digite seu email que enviaremos um link para modificação da senha',
	goback: 'Voltar',
	help: 'Ajuda',
	about: 'Sobre',
	helpRote: '/',
	aboutRote: '/',
	newAccount: 'Nova Conta',
	currentAccount: undefined,
	currentLang: 'Português (Brasil)',
	langs: [],
	hideForgotPassword: false,
	accounts: [],
	placeholdCompanies: 'Selecione uma Empresa',
	optionsCompanies: [],
	selectedCompanies: null,
	showCompanies: false,
	keyCompanies: 'name',
	resetPassword: false,
	setSelectedCompanies: () => {},
	onCompanies: () => {},
	onLang: () => {},
	onCurrentUser: () => {},
	onAccounts: () => {},
	onChange: () => {},
	onClickEnter: () => {},
	onClickBio: () => {},
	onGetUser: () => {},
	onGetPassword: () => {},
	onGetRecovery: () => {},
	onTheme: () => {},
	onResetSenha: () => {},
};



// WEBPACK FOOTER //
// ./src/componentes/login/index.jsx